import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import { PageTitle } from '@cordata/buffet';

import { UncontrolledTable } from '~/components/common';

import { useAdmin } from '~/utils/admin';

const defaultSorted = [{
  id: 'clinical-trial-name',
}];

const columns = [{
  id: 'clinicalTrialName',
  Header: 'Name',
  accessor: 'attributes.clinicalTrialName',
}, {
  id: 'clinicalTrialId',
  Header: 'Identifier',
  accessor: 'attributes.clinicalTrialId',
}, {
  id: 'status',
  Header: 'Status',
  accessor: 'attributes.status',
}];

const ClinicalTrials = () => {
  const history = useHistory();
  const { org } = useAdmin();

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to="/admin/clinical-trials/add"
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Clinical Trial</span>
          </Button>
        }
      >
        Clinical Trials
      </PageTitle>

      {org &&
        <UncontrolledTable
          name="clinical-trials"
          defaultSorted={defaultSorted}
          endpoint={{
            url: 'admin/clinical-trial',
            params: {
              'org-uid': org.id,
            },
          }}
          columns={columns}
          getTrProps={(state, rowInfo) => ({
              style: {
                cursor: 'pointer',
              },
              onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/admin/clinical-trials/${rowInfo.original.id}`)),
            })}
        />
      }
  </>
  );
};

export default ClinicalTrials;
